var _style, _path, _defs, _path2, _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdamame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{clip-path:url(#XMLID_2_);fill:#92B722;}\n\t.st2{fill:#D5DE6D;}\n\t.st3{fill:#AECB3F;}\n\t.st4{fill:#92B722;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000063627157982892912270000015677269547784765829_",
    d: "M74.84,92.87c-1.49-0.98-4.85-3.48-6.93-8.09 c-0.4-0.88-2.62-6-1.16-12.24c1.86-7.92,8.34-12.05,11.55-14.09c5.9-3.76,11.5-4.49,14.55-4.85c9.07-1.08,16.24,1.35,19.64,2.77 c3.47,1.45,8.47,3.55,12.71,8.78c0.79,0.97,4.54,5.75,5.78,13.17c0.43,2.58,1.16,7.32-0.69,12.71 c-2.34,6.8-8.67,14.26-17.79,15.48c-0.89,0.12-6.85,0.82-12.47-2.31c-2.73-1.52-2.3-2.22-5.54-4.16 c-3.61-2.15-5.62-2.16-12.24-4.39C80.54,95.07,77.96,94.16,74.84,92.87z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000063627157982892912270000015677269547784765829_",
    style: {
      overflow: "visible",
      fill: "#B7D04C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000063627157982892912270000015677269547784765829_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.22,56.72c-0.75,3.78-1.51,11.02,2.54,17.09c2.67,4,6.5,6.11,11.78,9.01c5,2.75,6.14,2.36,12.47,5.78 c6.47,3.48,6.07,4.31,9.01,5.08c6.86,1.8,13.27-1.59,15.94-3c5.21-2.75,8.51-6.56,10.4-9.24c0.47,2.42,1.94,11.42-3.47,19.17 c-6.83,9.8-19.37,10.07-23.79,10.16c-9.51,0.21-16.08-3.39-26.34-9.01c-12.68-6.94-20.41-11.18-23.1-20.1 c-1.76-5.81-1.93-15.47,4.39-21.02C64.64,57.49,68.95,56.86,71.22,56.72z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0756 -0.9971 0.9971 0.0756 27.5629 157.9561)",
    className: "st2",
    cx: 98.98,
    cy: 64.11,
    rx: 4.75,
    ry: 12.89
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -0.0869 0.0869 0.9962 -11.2429 10.4819)",
    className: "st3",
    cx: 114.84,
    cy: 134.45,
    rx: 30.72,
    ry: 23.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.45,131.78c-0.18-2.02-0.67-3.94-1.44-5.76c-1.74,11.22-13.44,20.61-28.38,21.92 c-14.31,1.25-26.99-5.33-31.24-15.34c-0.23,1.48-0.29,2.99-0.16,4.52c1.14,13.13,15.78,22.57,32.68,21.1 C133.82,156.74,146.59,144.91,145.45,131.78z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9942 -0.1074 0.1074 0.9942 -12.615 13.0488)",
    className: "st2",
    cx: 114.8,
    cy: 123.6,
    rx: 12.89,
    ry: 4.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdamame);
export default __webpack_public_path__ + "static/media/Edamame.9825e1a003957dddac26a438753fc161.svg";
export { ForwardRef as ReactComponent };